import { Route, Routes as RouterRoutes } from "react-router-dom";
import { NoGuidPage } from "pages/no-guid/no-guid";
import { SuspenseWrapper } from "components/suspenseWrapper";
import { lazy } from "react";
import { QrContent } from "pages/home/components";

const LazyPrivateRoute = lazy(() => import("components/privateRoute"));

export const Routes = () => {
  return (
    <SuspenseWrapper>
      <RouterRoutes>
        <Route path="/" element={<NoGuidPage />} />
        <Route path="/appjoin/:guid" element={<QrContent />} />
        <Route path=":guid" element={<LazyPrivateRoute />} />
        <Route path="*" element={<NoGuidPage />} />
      </RouterRoutes>
    </SuspenseWrapper>
  );
};
